import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Opens a page's create modal/drawer when the page is navigated to with
 * `state.openCreate` (the dashboard hero quick actions do this), then clears
 * the flag from history so refresh/back doesn't re-open it.
 */
export const useOpenCreateFromNav = (openCreate: () => void) => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if ((location.state as { openCreate?: boolean } | null)?.openCreate) {
      openCreate();
      navigate(location.pathname + location.search, { replace: true });
    }
    // Run once on mount — the flag only arrives with the initial navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
